﻿export function setupTestDriveTeaser(){
    $(document).on("click", "[data-test-drive-click]", function (e) {
        var clickValue = $(this).data('test-drive-click');
        if (clickValue !== "undefined") {
            $.get("/set-test-drive-click-count/" + clickValue, function (response) {

            });
        }
    });

}


